<template>
  <div>
    <div class="content-header">
      <div class="left">
        <Input v-model="page.key" placeholder="客户手机号" style="width:200px"></Input>
        <Button type="primary" style="margin-left:10px;" icon="ios-search" @click="getData">搜索</Button>
        <Button style="margin-left:10px;" @click="reset">重置</Button>
      </div>
      <div class="right"></div>
    </div>
    <Row style="font-size:20px;">
      <Col span="6">订单总额：{{total.total_money.toFixed(2)}}</Col>
      <Col span="6">已收金额：{{total.actual_payment.toFixed(2)}}</Col>
      <Col span="6">待确认金额：{{total.reviewedNot.toFixed(2)}}</Col>
      <Col span="6">待收金额：{{total.arrears.toFixed(2)}}</Col>
    </Row>
    <div style="margin-top:20px;">
      <Table :columns="col" :data="list"></Table>
      <div class="t-right t-top-10">
        <Page
          @on-change="pageChange"
          @on-page-size-change="sizeChange"
          :total="page.total"
          show-elevator
          show-sizer
          show-total
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      col: [
        { key: "name", title: "客户名称", width: 120 },
        {
          key: "user_type_name",
          title: "客户类型",
          width: 180,
        },
        {
          key: "user_type_name",
          title: "业务员",
          width: 180,
        },
        {
          key: "count_order",
          title: "订单数",
          width: 180,
        },
        {
          key: "total_money",
          title: "订单金额",
          width: 180,
          render: (h, data) => {
            return h("span", {}, data.row.total_money.toFixed(2));
          },
        },
        {
          key: "actual_payment",
          title: "已收金额",
          width: 180,
          render: (h, data) => {
            return h(
              "span",
              {},
              data.row.actual_payment
                ? data.row.actual_payment.toFixed(2)
                : "0.00"
            );
          },
        },
        {
          key: "arrears",
          title: "待收金额",
          width: 180,
          render: (h, data) => {
            return h(
              "span",
              {},
              data.row.arrears ? data.row.arrears.toFixed(2) : "0.00"
            );
          },
        },
        {
          key: "reviewedNot",
          title: "待确认金额",
          width: 180,
          render: (h, data) => {
            return h(
              "span",
              {},
              data.row.reviewedNot ? data.row.reviewedNot.toFixed(2) : "0.00"
            );
          },
        },
        {
          key: "staff_name",
          title: "业务员",
          width: 180,
        },
        {
          key: "action",
          title: "操作",
          width: 100,
          fixed: "right",
          render: (h, data) => {
            return h(
              "Button",
              {
                props: {
                  type: "success",
                  size: "small",
                  to: `/order/list?tel=${data.row.tel}`,
                },
                style: {},
                on: {
                  click: (e) => {
                    // this.$router.push()
                  },
                },
              },
              "款核"
            );
          },
        },
      ],

      list: [],
      page: {
        l: 10,
        p: 0,
        key: "",
        total: 0,
      },
      total: {
        total_money: 0,
        actual_payment: 0,
        arrears: 0,
        reviewedNot: 0,
      },
    };
  },
  mounted() {
    console.log("c,mounted");
    this.getData();
  },
  methods: {
    ...mapActions(["GetArrearsCustomer"]),
    getData() {
      this.GetArrearsCustomer(this.page).then((res) => {
        this.list = res.data;
        this.total = res.total;
        this.page.total = res.count;
      });
    },
    pageChange(p) {
      this.page.p = p - 1;
      this.getData();
    },
    sizeChange(l) {
      this.page.l = l;
      this.getData();
    },
    reset() {
      this.page = {
        l: 10,
        p: 0,
        key: "",
        total: 0,
      };
      this.getData();
    },
  },
  computed: {
    ...mapGetters({}),
    formatNumber(val) {
      let str = (val / 100).toFixed(2) + "";
      const intSum = str
        .substring(0, str.indexOf("."))
        .replace(/\B(?=(?:\d{3})+$)/g, ","); //取到整数部分
      let dot = str.substring(str.length, str.indexOf(".")); //取到小数部分搜索
      let ret = intSum + dot;
      return ret;
    },
  },
  watch: {},
};
</script>
<style lang='less'>
</style>
